// Change this URL to switch all public Artist Portal entry links.
// New portal: https://api.vieunite.com/artistportal
export const ARTIST_PORTAL_URL = '/artistportal/login';
